// extracted by mini-css-extract-plugin
module.exports = {"modal":"ProductDetailsModal_modal__bR7IN","modalBody":"ProductDetailsModal_modalBody__yuz04"};